/**
 * Initializes Grafana Faro for RUM, web vitals, errors, traces, and route changes.
 *
 * Belongs here: Faro SDK bootstrap and React Router v6 (no data router) wiring.
 * Does not belong here: Sentry init, product analytics, or OTLP / TelemetryProvider.
 */
import {
  createRoutesFromChildren,
  matchRoutes,
  Routes,
  useLocation,
  useNavigationType
} from 'react-router-dom'
import {
  createReactRouterV6Options,
  getWebInstrumentations,
  initializeFaro,
  ReactIntegration,
  setReactRouterV6SSRDependencies
} from '@grafana/faro-react'
import { TracingInstrumentation } from '@grafana/faro-web-tracing'
import { environment, faroApiKey, faroCollectorUrl } from '../env/environment'

/**
 * FaroRoutes renders this injected Routes component.
 * Dev skips initFaro, so register it on every boot or FaroRoutes receives undefined.
 */
export function registerFaroRouter() {
  setReactRouterV6SSRDependencies({ Routes })
}

/** Boots Faro against the self-hosted collector. Call once before render (non-dev). */
export function initFaro() {
  initializeFaro({
    url: faroCollectorUrl,
    ...(faroApiKey ? { apiKey: faroApiKey } : {}),
    app: {
      name: 'reactwebviews',
      version: '1.0.0',
      environment
    },
    instrumentations: [
      ...getWebInstrumentations(),
      new TracingInstrumentation(),
      new ReactIntegration({
        router: createReactRouterV6Options({
          createRoutesFromChildren,
          matchRoutes,
          Routes,
          useLocation,
          useNavigationType
        })
      })
    ]
  })
}
